import m from "../../geodata/es2015/nepalLow";
window.am4geodata_nepalLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/nepalLow.js
// module id = null
// module chunks = 